/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Edit/view.blocks to change it.
import EditModal from './EditModal/index'
import FileUploaderPluginS3 from 'DesignSystem/FileUploaderPluginS3/react'
import FileUploaderProvider from 'DesignSystem/FileUploaderProvider/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Edit({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/Edit",
  restrictions
  
}) {
  return (<React.Fragment
>
<FileUploaderProvider
  viewPath={`${viewPath}/FileUploaderProvider`}
 reset={true}
 restrictions={restrictions}
>
{childProps => (
<React.Fragment>
<FileUploaderPluginS3
{...childProps}
  viewPath={`${viewPath}/FileUploaderPluginS3`}
 isLegacyBucket={true}
 excludeKeyFileExtension={true}
 prefix="patientimg"
/>
<EditModal
{...childProps}
  viewPath={`${viewPath}/EditModal`}
/>
</React.Fragment>
)}
</FileUploaderProvider>
{children}
</React.Fragment>)
}